import {NuxtIcon} from "#components";
import {h} from "vue";
import { createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  id: "svg-LX-logo_svg__Layer_1",
  "data-name": "Layer 1",
  viewBox: "0 0 494 114.46"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _createElementVNode("defs", null, [
      (_openBlock(), _createBlock(_resolveDynamicComponent("style"), null, {
        default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
          _createTextVNode(".svg-LX-logo_svg__cls-2{fill:#cf0a2c}", -1)
        ]))]),
        _: 1
      }))
    ]),
    _cache[1] || (_cache[1] = _createElementVNode("path", {
      id: "svg-LX-logo_svg__Type",
      d: "M361.2 93.73h-19V20.48h19v73.25Zm-45-73.25-12.27 49.09-14.33-49.09h-18.38L256.9 69.57l-12.27-49.09H226l20.22 73.25h19.68l14.49-50.23 14.51 50.23h19.63l20.28-73.25H316.2ZM224.45 73c0-14-7.45-18.75-23.74-24.06-7.68-2.5-14.85-4.43-14.85-10.4 0-5.23 5.33-7 9.31-7 3.37 0 9.71.71 10.22 8.48h18c-.31-14.83-12.37-21.29-27.9-21.29-9.62 0-17.57 2.73-22.58 7.66-3.61 3.66-5.63 8.6-5.62 13.74 0 13.64 9.11 19.1 19.4 22.23 11.57 3.53 19.22 5.64 19.22 12 0 4.25-3.38 8.49-10 8.49-8.46 0-11.53-5-11.73-10h-18.2c0 16.88 14.23 23.06 29.93 23.06 20 0 28.58-11.42 28.58-22.94m204 0c0-16.15-11.75-20.42-26-24.67-6.85-2-13-3.82-13-9.79 0-5.23 5.32-7 9.31-7 3.39 0 9.7.71 10.21 8.48h18c-.31-14.83-12.36-21.29-27.91-21.29-9.61 0-17.59 2.73-22.57 7.66-3.61 3.66-5.63 8.6-5.62 13.74 0 13.64 9.09 19.1 19.41 22.23 11.56 3.53 19.23 5.64 19.23 12 0 4.25-3.37 8.49-10 8.49-8.48 0-11.56-5-11.74-10h-18.2c0 16.88 14.22 23.06 29.94 23.06 20 0 28.93-11.42 28.93-22.94m65.44 0c0-16.15-11.81-20.42-26-24.67-6.87-2-13-3.82-13-9.79 0-5.23 5.29-7 9.28-7 3.36 0 9.71.71 10.22 8.48h18c-.31-14.83-12.43-21.29-27.93-21.29-9.49.11-17.49 2.84-22.49 7.77-3.6 3.67-5.62 8.6-5.61 13.74 0 13.64 9.09 19.1 19.4 22.23 11.57 3.53 19.22 5.64 19.22 12 0 4.25-3.36 8.49-10 8.49-8.48 0-11.55-5-11.75-10H435c0 16.88 14.2 23.1 30 23.1 20.07 0 29-11.42 29-22.94",
      class: "svg-LX-logo_svg__cls-2"
    }, null, -1)),
    _cache[2] || (_cache[2] = _createElementVNode("path", {
      id: "svg-LX-logo_svg__Tailfin",
      d: "M125.26 114.46H0L91.81 0h61.65l-28.2 114.46z",
      class: "svg-LX-logo_svg__cls-2"
    }, null, -1)),
    _cache[3] || (_cache[3] = _createElementVNode("path", {
      id: "svg-LX-logo_svg__Cross",
      d: "M106.09 46.67V22.03H84.97v24.64H60.33v21.12h24.62v24.65h21.13V67.79h24.66V46.67h-24.65z",
      style: {"fill":"#fff"}
    }, null, -1))
  ]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "LX-logo"}) } }